export const tutorialsByRoute = {
  "/geo-comparison": [
    {
      id: "geo-comparison-overview",
      title: "GEO Comparison Basics",
      titleKey: "tutorials.geoComparisonBasics",
      markdownPath: "/guides/geo-comparison.md",
    },
    {
      id: "geo-comparison-analyzing",
      title: "Analyzing Comparison Data",
      titleKey: "tutorials.analyzingComparisonData",
      markdownPath: "/guides/geo-comparison-analyzing.md",
    },
  ],
  "/geo-dashboard": [
    {
      id: "geo-dashboard-overview",
      title: "GEO Dashboard Basics",
      titleKey: "tutorials.geoDashboardBasics",
      markdownPath: "/guides/geo-dashboard.md",
    },
    {
      id: "geo-dashboard-citations-vs-mentions",
      title: "Citations vs. Mentions Explained",
      titleKey: "tutorials.citationsVsMentions",
      markdownPath: "/guides/geo-dashboard-citations-vs-mentions.md",
    },
  ],
  "/optimize-content": [
    {
      id: "optimize-content-overview",
      title: "Optimize Content Workflow",
      titleKey: "tutorials.optimizeContentWorkflow",
      markdownPath: "/guides/optimize-content.md",
    },
    {
      id: "optimize-content-review-score",
      title: "Using the Content Review Score",
      titleKey: "tutorials.usingReviewScore",
      markdownPath: "/guides/optimize-content-review-score.md",
    },
  ],
  "/prompt-research": [
    {
      id: "prompt-research-overview",
      title: "Prompt Research Quickstart",
      titleKey: "tutorials.promptResearchQuickstart",
      markdownPath: "/guides/prompt-research.md",
    },
    {
      id: "prompt-research-reading-results",
      title: "Analyzing Research Results",
      titleKey: "tutorials.analyzingResearchResults",
      markdownPath: "/guides/prompt-research-reading-results.md",
    },
  ],
  "/answer-engine": [
    {
      id: "answer-engine-overview",
      title: "Answer Engine Essentials",
      titleKey: "tutorials.answerEngineEssentials",
      markdownPath: "/guides/answer-engine.md",
    },
    {
      id: "answer-engine-sandbox-analytics",
      title: "Sandbox Testing & Analytics",
      titleKey: "tutorials.sandboxTestingAnalytics",
      markdownPath: "/guides/answer-engine-sandbox-analytics.md",
    },
  ],
  "/super-admin": [
    {
      id: "super-admin-overview",
      title: "Super Admin Core Actions",
      titleKey: "tutorials.superAdminCoreActions",
      markdownPath: "/guides/super-admin.md",
    },
    {
      id: "super-admin-users-clients",
      title: "Managing Users & Clients",
      titleKey: "tutorials.managingUsersClients",
      markdownPath: "/guides/super-admin-users-clients.md",
    },
  ],
  "/settings": [
    {
      id: "settings-overview",
      title: "Settings Page Guide",
      titleKey: "tutorials.settingsPageGuide",
      markdownPath: "/guides/settings.md",
    },
    {
      id: "settings-thresholds",
      title: "Configuring Thresholds & Localization",
      titleKey: "tutorials.configuringThresholds",
      markdownPath: "/guides/settings-thresholds.md",
    },
  ],
  "/profile": [
    {
      id: "profile-overview",
      title: "Profile Update Guide",
      titleKey: "tutorials.profileUpdateGuide",
      markdownPath: "/guides/profile.md",
    },
    {
      id: "profile-avatar-password",
      title: "Updating Avatar & Password",
      titleKey: "tutorials.updatingAvatarPassword",
      markdownPath: "/guides/profile-avatar-password.md",
    },
  ],
  "/tracking": [
    {
      id: "tracking-overview",
      title: "Tracking Page Basics",
      titleKey: "tutorials.trackingPageBasics",
      markdownPath: "/guides/tracking.md",
    },
    {
      id: "tracking-interpreting-results",
      title: "Interpreting Tracking Results",
      titleKey: "tutorials.interpretingTrackingResults",
      markdownPath: "/guides/tracking-interpreting-results.md",
    },
  ],
  "/edit-prompt": [
    {
      id: "edit-prompt-overview",
      title: "Edit Prompt Walkthrough",
      titleKey: "tutorials.editPromptWalkthrough",
      markdownPath: "/guides/edit-prompt.md",
    },
    {
      id: "edit-prompt-add-remove",
      title: "Adding & Removing Prompts",
      titleKey: "tutorials.addingRemovingPrompts",
      markdownPath: "/guides/edit-prompt-add-remove.md",
    },
  ],
  "/archived-prompt-qr": [
    {
      id: "historical-prompt-qr-overview",
      title: "Historical Prompt QR Guide",
      titleKey: "tutorials.historicalPromptQrGuide",
      markdownPath: "/guides/historical-prompt-qr.md",
    },
    {
      id: "historical-prompt-qr-filtering",
      title: "Filtering & Comparing Records",
      titleKey: "tutorials.filteringComparingRecords",
      markdownPath: "/guides/historical-prompt-qr-filtering.md",
    },
  ],
  "/historical-prompt-qr": [
    {
      id: "historical-prompt-qr-overview",
      title: "Historical Prompt QR Guide",
      titleKey: "tutorials.historicalPromptQrGuide",
      markdownPath: "/guides/historical-prompt-qr.md",
    },
    {
      id: "historical-prompt-qr-filtering",
      title: "Filtering & Comparing Records",
      titleKey: "tutorials.filteringComparingRecords",
      markdownPath: "/guides/historical-prompt-qr-filtering.md",
    },
  ],
};

export const getTutorialsForPath = (pathname) => tutorialsByRoute[pathname] || [];
